import React, { useState, useEffect } from 'react';
import { getStyles } from '../styles';
import { useTheme } from '@mui/material/styles';
import Modal from '@mui/material/Modal';
import { Box, Typography, CircularProgress } from '@mui/material';
import { BatchChangeDTO } from '@beable/roster-backend-client-v1';
import batchService from '../../../services/BatchService';


function getModalStyle() {
  const top = 50;
  const left = 50;

  return {
    top: `${top}%`,
    left: `${left}%`,
    transform: `translate(-${top}%, -${left}%)`,
  };
}

interface BatchChangesModalProps {
    open: boolean;
    batchId: string;
    selectedFile: string | null;
    handleClose: () => void;
}

const initialBatchChangesValue: BatchChangeDTO = {
    batchId: '',
    content: '',
    fileName: ''
}

export default function ChangesModal({ open, batchId, selectedFile, handleClose }: BatchChangesModalProps) {
  const theme = useTheme();
  const styles = getStyles(theme);
  // getModalStyle is not a pure function, we roll the style only on the first render
  const [modalStyle] = useState(getModalStyle);
  const [isBatchChangesLoading, setIsBatchChangesLoading] = useState(false);
  const [batchChanges, setBatchChanges] = useState(initialBatchChangesValue);

  useEffect(() => {
    async function fetchChanges () {
        setIsBatchChangesLoading(true);
        const changes = await batchService.getBatchChangeReport(batchId, selectedFile);
        if (changes)
            setBatchChanges(changes);

        setIsBatchChangesLoading(false);
    }

    if (open) {
      fetchChanges();
    }
  }, [open, batchId, selectedFile])


  return (
      <Modal
        aria-labelledby="simple-modal-title"
        aria-describedby="simple-modal-description"
        open={open}
        onClose={handleClose}
      >
        <Box sx={[styles.changesModal, modalStyle]}>
            <Typography variant="h4">Changes Report</Typography>
            {isBatchChangesLoading &&
                <Box sx={styles.placeHolder}>
                    <CircularProgress disableShrink />
                </Box>}
            {!isBatchChangesLoading &&
                <div dangerouslySetInnerHTML={{ __html: batchChanges.content }} />}
        </Box>
      </Modal>
  );
}
